<template>
  <ModalDialog
    v-if="modal.content"
    :visible="modal.visible"
    :content="modal.content"
    :class="cssClass"
    @close="modal.close()"
  />
  <HalfSheet
    v-if="sheet.content"
    :visible="sheet.visible"
    :content="sheet.content"
    :class="cssClass"
    @close="sheet.close()"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useThemeStore } from '@/stores'
import { ModalDialog } from '@oatsovernight/storybook'
import HalfSheet from './half-sheet.vue'

const { modal, sheet } = useThemeStore()

const cssClass = computed(() => {
  const { content } = modal || sheet || {}
  return content?.component && '__name' in content.component && content.component.__name
})
</script>
